import { SPECIAL_KEYS } from '../utils/constants';
import { CandidatesKeyboard, KeyboardModule } from 'components/Keyboard/types';
import { syncShiftTheme } from './shiftLock';

const LAYOUT_BY_KEY: Partial<Record<string, string>> = {
  [SPECIAL_KEYS.SPECIAL]: 'special',
  [SPECIAL_KEYS.DEFAULT]: 'default',
};

function layoutSwitch(keyboard: CandidatesKeyboard) {
  keyboard.registerModule('layoutSwitch', (module: KeyboardModule) => {
    module.fn = { handleButtonClicked: keyboard.handleButtonClicked };

    keyboard.handleButtonClicked = (...args) => {
      const [button] = args;
      const nextLayout = LAYOUT_BY_KEY[button];

      if (nextLayout) {
        keyboard.flushCandidates?.();
        keyboard.setOptions({ layoutName: nextLayout });
        syncShiftTheme(keyboard);
      }

      return module.fn.handleButtonClicked.call(keyboard, ...args);
    };
  });
}

export default layoutSwitch;
